import { render, staticRenderFns } from "./ClientProjectsAll.vue?vue&type=template&id=97c6932a&scoped=true"
import script from "./ClientProjectsAll.vue?vue&type=script&lang=ts"
export * from "./ClientProjectsAll.vue?vue&type=script&lang=ts"
import style0 from "./ClientProjectsAll.vue?vue&type=style&index=0&id=97c6932a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c6932a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97c6932a')) {
      api.createRecord('97c6932a', component.options)
    } else {
      api.reload('97c6932a', component.options)
    }
    module.hot.accept("./ClientProjectsAll.vue?vue&type=template&id=97c6932a&scoped=true", function () {
      api.rerender('97c6932a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/ClientProjectsAll.vue"
export default component.exports